import React from 'react';

import { Brain } from 'lucide-react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors } from './icon-utils';

export function AIReasoningIcon({
  className,
  fill = 'none',
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface): JSX.Element {
  return <Brain className={className} fill={fill} height={height} stroke={stroke} width={width} />;
}
